import Adjust from '@adjustcom/adjust-web-sdk';

export { Adjust };